import React, { ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import {
  getPartnerId,
  ManagementPartner,
} from '../../../components/society/ManagementPartner/management_partner'
import { societyHasActivatedPartner } from '../../../helpers/society'
import { UnauthorizedView } from '../../../views/error/UnauthorizedView'
import { useSelectedSocietyId } from '../../../hooks/useSelectedSocietyContext'
import { societyQueries } from '../../../api/societies'

interface PartnerRouteProps {
  children: React.ReactNode
  partner: ManagementPartner
}

const PartnerRoute = ({ children, partner }: PartnerRouteProps): ReactNode => {
  const { selectedSocietyId } = useSelectedSocietyId()
  const { data: selectedSociety, isLoading } = useQuery(
    societyQueries.getSociety(selectedSocietyId)
  )

  const canAccessPartnerRoute = societyHasActivatedPartner(
    selectedSociety,
    getPartnerId(partner)
  )

  if (isLoading) return null

  return <>{canAccessPartnerRoute ? children : <UnauthorizedView />}</>
}

export { PartnerRoute }
